import { ActionStatus, buildActionType } from '../core';

const resetState = type => dispatch => dispatch({ type: buildActionType(type, ActionStatus.RESET) });

export { resetState };
